/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indexesGet } from "../../funcs/indexesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetIndexRequest$inboundSchema,
};

export const tool$indexesGet: ToolDefinition<typeof args> = {
  name: "indexes-get",
  description: `Get an index

Get the details of an index by index name.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await indexesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
